<template>
    <router-view :key="route.params.id"
      :content_state="content_state"
      :identities_controller="identities_controller"
      :contacts_controller="contacts_controller"
    >
    </router-view>
</template>

<script setup>
  import { onBeforeMount, reactive, watch } from 'vue';
  import { useRoute }                       from 'vue-router';
  import IdentitiesController               from '@/js/Settings/Identities/IdentitiesController';
  import ContactsController                 from '@/js/Contacts/ContactsController';
  import ContentState                       from '@/js/Shared/State/ContentState';

  const identities_controller = reactive(IdentitiesController);
  const contacts_controller   = reactive(ContactsController);
  const content_state         = reactive(new ContentState());
  const route                 = useRoute();

  watch(() => route.params.id, () => {
    validateIdentityId();
  });

  onBeforeMount(async () => {
    await fetchIdentities();
    validateIdentityId();
  })

  content_state.onErrorRetry(async () => {
    await fetchIdentities();
    validateIdentityId();
  })

  const fetchIdentities = async () => {
    content_state.setLoading();
    await ContactsController.fetchContactsOnce();
    content_state.setLoadedState(
      await identities_controller.fetchIdentities()
    );
  }

  const validateIdentityId = () => {
    if (route.name !== 'identities-edit') {
      content_state.setFoundState(true);
      return;
    }

    content_state.setFoundState(
      identities_controller.identities.exists(route.params.id)
    );
  }
</script>